import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from "react";

export interface ActiveEmailMeta {
  messageId: string;
  to: string;
  subject: string;
  userId: string;
  tenantId: string;
}

interface EmailContextValue {
  emailMeta: ActiveEmailMeta | null;
  setEmailMeta: (meta: ActiveEmailMeta | null) => void;
  pendingDraft: string | null;
  setPendingDraft: (draft: string | null) => void;
}

const EmailContext = createContext<EmailContextValue>({
  emailMeta: null,
  setEmailMeta: () => {},
  pendingDraft: null,
  setPendingDraft: () => {},
});

export function EmailProvider({ children }: { children: ReactNode }) {
  const [emailMeta, setEmailMetaState] = useState<ActiveEmailMeta | null>(null);
  const [pendingDraft, setPendingDraftState] = useState<string | null>(null);
  const setEmailMeta = useCallback(
    (m: ActiveEmailMeta | null) => setEmailMetaState(m),
    [],
  );
  const setPendingDraft = useCallback(
    (d: string | null) => setPendingDraftState(d),
    [],
  );
  return (
    <EmailContext.Provider
      value={{ emailMeta, setEmailMeta, pendingDraft, setPendingDraft }}
    >
      {children}
    </EmailContext.Provider>
  );
}

export function useEmailContext() {
  return useContext(EmailContext);
}
